import Vue from 'vue';
import VueRouter from 'vue-router';
import Main from '../views/Main.vue';
import Home from '../components/Home.vue';
import Sites from '../components/Sites.vue';
import SignInList from '../components/SignInList.vue';
import PublicSignIn from '../components/public/PublicSignIn.vue';
import * as auth from '../lib/auth';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/visitor-sign-in',
    component: Main,
    children: [
      {
        path: 'home',
        name: 'Home',
        component: Home,
        props: true,
        meta: { hideHeader: false },
        beforeEnter: async (to, from, next) => {
          const authenticated = await auth.isAuthenticated();
          if (!authenticated) {
            return auth.authenticate();
          }
          return next();
        },
      },
      {
        path: 'sites',
        name: 'Sites',
        component: Sites,
        props: true,
        beforeEnter: async (to, from, next) => {
          const authenticated = await auth.isAuthenticated();
          if (!authenticated) {
            return auth.authenticate();
          }
          return next();
        },
      },
      {
        path: 'sign-ins/:siteId?',
        name: 'Sign Ins',
        component: SignInList,
        props: true,
        beforeEnter: async (to, from, next) => {
          const authenticated = await auth.isAuthenticated();
          if (!authenticated) {
            return auth.authenticate();
          }
          return next();
        },
      },
      {
        path: 'logout',
        name: 'Logout',
        props: true,
        beforeEnter: (to, from, next) => {
          auth.logout();
          next();
        },
      },
      {
        path: 'visitor-sign-in',
        name: 'Visitor Sign In',
        component: PublicSignIn,
        props: true,
        beforeEnter: async (to, from, next) => {
          const authenticated = await auth.isAuthenticated();
          if (authenticated) {
            return next('home');
          }
          return next();
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
